module.exports = __webpack_public_path__ + "media/images/photo/plans/common/img_story-photo-0d7292f76a0106a047ce170d9566a26b.jpg";